/**
 * Returns true when the browser tab/page is visible to the user.
 * Use at the top of polling callbacks to skip network requests while hidden.
 */
export function isPageVisible(): boolean {
  return typeof document === 'undefined' || !document.hidden
}
